module.exports = __webpack_public_path__ + "media/src/images/partners/itmo-d106cca894c58dc3cf02615f971c257c.png";